import { OrderType } from 'models/Order'
import { Product } from 'models/Product'
import { useQuery, UseQueryOptions } from 'react-query'
import { ApiClient } from 'services/ApiClient'
import { Api } from 'types/Api'

export namespace FetchRelatedProducts {
  export type Response = { products: Product[] }
  export type Error = Api.Error
  export type Options = UseQueryOptions<Response, Error>
}

const createKey = (productId: string) => ['related-products', productId]

const queryFetcher = (productId: string) => () => {
  return ApiClient.post<FetchRelatedProducts.Response>(
    `/v1/products/${productId}/related/preview`,
    { data: { discount: { orderType: OrderType.PRODUCTS_SUBSCRIPTION } } }
  )
}

export const useFetchRelatedProducts = (
  productId: string,
  options?: FetchRelatedProducts.Options
) => {
  return useQuery<FetchRelatedProducts.Response, FetchRelatedProducts.Error>(
    createKey(productId),
    queryFetcher(productId),
    options
  )
}
